/**
 * Converts a clone URL to an LTI (Learning Tools Interoperability) launch URL.
 *
 * This function transforms URLs containing "/clone/" into LTI-compatible URLs
 * by replacing the path segment with "/lti/newsela/launch/clone/".
 *
 * @param url - The URL to convert
 * @returns The formatted LTI launch URL, or an empty string if no URL is provided.
 */

export const normalizeLTILaunchUrl = (url?: string): string => {
  if (!url) return "";

  // If URL is already formatted with LTI launch path, return as-is
  if (url.includes("/lti/newsela/launch/clone/")) {
    return url;
  }

  // Prioritize replacing formative.com/clone if it exists
  if (url.includes("formative.com/clone")) {
    return url.replace(
      "formative.com/clone/",
      "formative.com/lti/newsela/launch/clone/",
    );
  }

  // Otherwise, replace the first occurrence of /clone/
  return url.replace("/clone/", "/lti/newsela/launch/clone/");
};
